export const EEditMenuActions = {
	upload: 'uploadNew',
	clear: 'clear',
} as const;

export const editMenuActions = [
	{
		text: 'Upload new',
		id: EEditMenuActions.upload,
		disabled: false,
	},
	{
		text: 'Clear',
		id: EEditMenuActions.clear,
		disabled: false,
	},
];
